export default __webpack_public_path__ + "static/media/redCheck.0615bab8.svg";